/*jshint esversion: 9 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";

// add dialog
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import ImageListItemBar from "@material-ui/core/ImageListItemBar";
import IconButton from "@material-ui/core/IconButton";
import { toJS } from "mobx";

import store from "../../../components/stores/Store";
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import FormData from "form-data";
// import Slide from '@material-ui/core/Slide';

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import { imgHostIp } from "../../../config/ips";

import {
  verifyTicket,
  unverifyTicket,
  deleteTicket,
  getImageUrls,
  deleteImage,
  updateTicket,
} from "../../../db/TicketRequestHandler";
import { uploadImagesForTicket } from "../../../db/ImageRequestHandler";
import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

let formData;
let gfiles = [];

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    minWidth: "100%",
    // marginBottom: theme.spacing(2),
    // maxWidth: '140%', // todo
  },
  tableContainer: {
    maxHeight: "550px", // todo
    // mimWidth: '2000px', // todo
    // maxWidth: '2000px', // todo
  },
  table: {
    // minWidth: '2000px',
    // maxWidth: '2000px', // todo
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
  imageList: {
    width: 500,
    height: 450,
  },
  dateField: {},
  smallButton: {
    padding: 0,
  },
  TableCell: {
    borderRight: 'solid',
    borderRightColor: '#eee'
  },
};
// TableOfRoomTicketInfoManagement
class TableOfRoomTicketInfoManagementInner extends Component {
  constructor() {
    super();
    store.setOrderByOfTableConfig("ticketNo");
    store.setOrderOfTableConfig("desc");
    this.state = {
      login: true,
      uploadImagesDialogOpen: false,
      attachmentDialogOpen: false,
      ticketIdToUploadImg: "",
      updateTicketDialogOpen: false,
      bigImageDialogOpen: false,
      deleteLineDialogOpen: false,
      toDeleteId: '',
      bigImageUrl: "",
      updateTicketParams: {
        subarea: "",
        ID: "",
        ticketNo: "",
        ticketHolder: "",
        mobileNumber: "",
        idCard: "",
        buyer: "",
        mobileNumber2: "",
        idCard2: "",
        relationship: "",
        validPeriod: "",
        remarks: "",
        ticketAmount: "",
      },
      tableContainerHeight: '500px',
      imgInfoList: [],
    };
    this.sampleMehtod = this.sampleMehtod.bind(this);
    this.createData = this.createData.bind(this);
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);

    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.handleChangePage = this.handleChangePage.bind(this);

    this.sortHandler = this.sortHandler.bind(this);
    this.verifyTicket = this.verifyTicket.bind(this);
    this.unverifyTicket = this.unverifyTicket.bind(this);

    this.showAttachment = this.showAttachment.bind(this);
    this.uploadImages = this.uploadImages.bind(this);
    this.openUploadImagesDialog = this.openUploadImagesDialog.bind(this);
    this.selectImages = this.selectImages.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.updateLine = this.updateLine.bind(this);
    this.uploadProfilePic = this.uploadProfilePic.bind(this);
    this.closeUploadImagesDialog = this.closeUploadImagesDialog.bind(this);
    this.closeAttachmentDialog = this.closeAttachmentDialog.bind(this);
    this.openBigImageDialog = this.openBigImageDialog.bind(this);
    this.closeBigImageDialog = this.closeBigImageDialog.bind(this);
    this.doUpdateLine = this.doUpdateLine.bind(this);
    this.closeUpdateTicketDialog = this.closeUpdateTicketDialog.bind(this);
    this.calcSize = this.calcSize.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() {
    this.calcSize();
  }
  componentWillUnmount() { }

  sampleMehtod(e) {
    console.log(e);
  }

  calcSize() {
    // const innerWidth  = window.innerWidth;
    const innerHeight = window.innerHeight;
    this.setState({
      tableContainerHeight: `${innerHeight - 300}px`,
    });
  }

  createData(
    subarea,
    ticketNo,
    ticketHolder,
    mobileNumber,
    idCard,
    buyer,
    mobileNumber2,
    idCard2,
    relationship,
    ticketAmount,
    state,
    purchaseStatus,
    validPeriod,
    remarks,
    actions
  ) {
    return {
      subarea,
      ticketNo,
      ticketHolder,
      mobileNumber,
      idCard,
      buyer,
      mobileNumber2,
      idCard2,
      relationship,
      ticketAmount,
      state,
      purchaseStatus,
      validPeriod,
      remarks,
      actions,
    };
  }
  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      },
    });
  }

  handleChangePage(event, newPage) {
    console.log(`----- handleChangePage-newPage: `, newPage);
    store.setCurrentPageOfTableConfig(newPage);
    store.search();
  }

  handleChangeRowsPerPage(event) {
    store.setRowsPerPageOfTableConfig(parseInt(event.target.value, 10));
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  sortHandler(event, header) {
    if (!header.sortable) return;
    const orderBy = header.id;
    const order   = (orderBy === store.tableConfig.orderBy && store.tableConfig.order === 'asc') ? 'desc' : 'asc';
    console.log(`----- order  : `, order);
    console.log(`----- orderBy: `, orderBy);
    store.setOrderByOfTableConfig(orderBy);
    store.setOrderOfTableConfig(order);
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  async verifyTicket(e, row, index) {
    console.log(
      `----- send req of verifyTicket: ID:'${row.ID}' - ticketNo: '${row.ticketNo}'`
    );
    const rst = await verifyTicket({ ID: row.ID });
    console.log(`----- verifyTicket rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "审核错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "审核成功");
      store.search();
      return true;
    }
  }

  async unverifyTicket(e, row, index) {
    console.log(
      `----- send req of unverifyTicket: ID:'${row.ID}' - ticketNo: '${row.ticketNo}'`
    );
    const rst = await unverifyTicket({ ID: row.ID });
    console.log(`----- unverifyTicket rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "反审错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "反审成功");
      store.search();
      return true;
    }
  }

  async showAttachment(e, row) {
    const rst = await getImageUrls({ relateId: row.ID });
    if (rst.code === "error" || !rst.data) {
      store.openMessageDialogOpen(rst.msg || "附件查询错误");
      return true;
    }
    const imgInfoList = [];
    for (let index = 0; index < rst.data.length; index++) {
      const element = rst.data[index];
      if (element.isdeleted === "1") continue;
      imgInfoList.push({
        id: '',
        url: `${imgHostIp}/${element.url}`,
        new: false,
        delete: false,
        display: true,
        uploaded: false,
        data: {},
      });
    }
    this.setState({
      attachmentDialogOpen: true,
      imgInfoList: imgInfoList,
    });
  }

  async openUploadImagesDialog(e, id) {
    // 从服务器获取图片网址展示
    const rst = await getImageUrls({ relateId: id });
    if (rst.code === "error" || !rst.data) {
      store.openMessageDialogOpen(rst.msg || "附件查询错误");
      return true;
    }
    const imgInfoList = [];
    for (let index = 0; index < rst.data.length; index++) {
      const element = rst.data[index];
      if (element.isdeleted === "1") continue;
      imgInfoList.push({
        id: element.ID,
        url: `${imgHostIp}/${element.url}`,
        new: false,
        delete: false,
        display: true,
        uploaded: false, // true: 已经上传过
        data: {},
      });
    }
    this.setState({
      imgInfoList: imgInfoList,
      uploadImagesDialogOpen: true,
      ticketIdToUploadImg: id,
    });
  }

  selectImages() {
    // 选取文件
  }

  async closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteRole`);
    const rst = await deleteTicket({ ID: id });
    console.log(`----- rst of deleteRole: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ addDialogOpen: false });
      store.search();
      return true;
    }
  }

  // 上传图片
  async uploadImages() {
    const ticketIdToUploadImg = this.state.ticketIdToUploadImg;
    let successCount = 0;
    const imgInfoList = this.state.imgInfoList;
    for (let index = 0; index < imgInfoList.length; index++) {
      const imgInfo = imgInfoList[index];
      if (!imgInfo.new) continue;
      if (imgInfo.uploaded) continue; // 已经上传过了
      formData = new FormData();
      formData.append("file", imgInfo.data);
      formData.append("ticketid", ticketIdToUploadImg || "");
      formData.append("marketId", store.marketId);
      formData.append("createBy", store.user.uuid);
      const authorization = toJS(store.user.JWTToken);
      formData.append("authorization", authorization);
      const rst = await uploadImagesForTicket(formData);
      if (rst.code === "success") {
        imgInfoList[index].uploaded = true; // 非刷新，设置为"已经上传过了"
        successCount = successCount + 1;
      } else {
        store.openMessageDialogOpen("上传失败，请重新上传");
        break;
      }
      if (successCount === gfiles.length) {
        store.openMessageDialogOpen("上传成功");
        this.closeUploadImagesDialog();
      }
    }
    this.setState({ imgInfoList });
  }

  async deleteImage(e, item, index) {
    e.stopPropagation();
    const imgInfoList = this.state.imgInfoList;
    if (!imgInfoList[index].new) {
      const rst = await deleteImage({ id: imgInfoList[index].id });
      if (rst.code === "success") {
        store.openMessageDialogOpen("图片删除成功");
      } else {
        store.openMessageDialogOpen("图片删除失败");
        return;
      }

      imgInfoList[index].delete = false;
    }
    imgInfoList[index].new = false;
    imgInfoList[index].display = false;
    this.setState({
      imgInfoList: imgInfoList,
    });
  }

  async uploadProfilePic(e) {
    console.log(`----- uploadProfilePic`);
    gfiles = Array.from(e.target.files);
    const imgInfoList = this.state.imgInfoList;
    for (let index = 0; index < gfiles.length; index++) {
      const file = gfiles[index];
      imgInfoList.push({
        id: '',
        url: URL.createObjectURL(file),
        new: true,
        delete: false,
        display: true,
        uploaded: false,
        data: file,
      });
    }
    this.setState({
      imgInfoList: imgInfoList,
    });
  }

  async updateLine(e, row) {
    this.setState({
      updateTicketDialogOpen: true,
      updateTicketParams: {
        subarea: row.subarea || '',
        ID: row.ID,
        ticketNo: row.ticketNo,
        ticketHolder: row.ticketHolder,
        ticketAmount: row.ticketAmount,
        mobileNumber: row.mobileNumber,
        idCard: row.idCard,
        buyer: row.buyer,
        mobileNumber2: row.mobileNumber2,
        idCard2: row.idCard2,
        relationship: row.relationship,
        validPeriod: row.validPeriod,
        startDate: row.validPeriod.split(" ")[0],
        endDate: row.validPeriod.split(" ")[1],
        remarks: row.remarks,
      },
    });
  }

  closeUploadImagesDialog() {
    gfiles = [];
    this.setState({
      uploadImagesDialogOpen: false,
      imgInfoList: [],
      ticketIdToUploadImg: "",
    });
  }

  closeAttachmentDialog() {
    gfiles = [];
    this.setState({
      attachmentDialogOpen: false,
      imgInfoList: [],
      ticketIdToUploadImg: "",
    });
  }

  onTicketDialogChange(e, prop) {
    e.stopPropagation();
    console.log(
      `----- onTicketDialogChange-updateTicketParams: `,
      this.state.updateTicketParams
    );
    const newUpdateTicketParams = this.state.updateTicketParams;
    newUpdateTicketParams[prop] = e.target.value;
    this.setState({ updateTicketParams: newUpdateTicketParams });
  }

  openBigImageDialog(url) {
    console.log(`----- openBigImageDialog-url: `, url);
    this.setState({
      bigImageDialogOpen: true,
      bigImageUrl: (url || '').replace('-thumb', ''), // 显示全尺寸整的图片
    });
  }

  closeBigImageDialog() {
    this.setState({
      bigImageDialogOpen: false,
      bigImageUrl: "",
    });
  }

  async doUpdateLine() {
    console.log(`----- doUpdateLine 1`);
    const subarea = (this.state.updateTicketParams.subarea || '').trim();
    const ID = this.state.updateTicketParams.ID.trim();
    const ticketNo = this.state.updateTicketParams.ticketNo.trim();
    const ticketHolder = this.state.updateTicketParams.ticketHolder.trim();
    const mobileNumber = this.state.updateTicketParams.mobileNumber.trim();
    const idCard = this.state.updateTicketParams.idCard.trim();
    const buyer = this.state.updateTicketParams.buyer.trim();
    const mobileNumber2 = this.state.updateTicketParams.mobileNumber2.trim();
    const idCard2 = this.state.updateTicketParams.idCard2.trim();
    const relationship = this.state.updateTicketParams.relationship.trim();
    const startDate = this.state.updateTicketParams.startDate.trim();
    const endDate = this.state.updateTicketParams.endDate.trim();
    const remarks = (this.state.updateTicketParams.remarks || '').trim();
    const ticketAmount = this.state.updateTicketParams.ticketAmount.trim();

    const chkRst = CheckHandler.checkParams([
      { key: "区域", value: subarea, notNull: false, type: "", maxLength: 20 },
      { key: "房票ID", value: ID, notNull: true, type: "", maxLength: 64 },
      {
        key: "票号",
        value: ticketNo,
        notNull: true,
        type: "int",
        maxLength: 20,
      },
      {
        key: "被搬迁户",
        value: ticketHolder,
        notNull: true,
        type: "",
        maxLength: 10,
      },
      {
        key: "被搬迁户手机号",
        value: mobileNumber,
        notNull: true,
        type: "phone",
        maxLength: 11,
      },
      {
        key: "被搬迁户身份证号码",
        value: idCard,
        notNull: true,
        type: "idnum",
        maxLength: 18,
      },
      { key: "房票使用人", value: buyer, notNull: true, type: "", maxLength: 10 },
      {
        key: "房票使用人手机号",
        value: mobileNumber2,
        notNull: true,
        type: "phone",
        maxLength: 11,
      },
      {
        key: "房票使用人身份证号码",
        value: idCard2,
        notNull: true,
        type: "idnum",
        maxLength: 18,
      },
      {
        key: "被搬迁户与房票使用人关系",
        value: relationship,
        notNull: true,
        type: "",
        maxLength: 10,
      },
      {
        key: "开始日期",
        value: startDate,
        notNull: true,
        type: "",
        maxLength: 10,
      },
      {
        key: "结束日期",
        value: endDate,
        notNull: true,
        type: "",
        maxLength: 10,
      },
      { key: "备注", value: remarks, notNull: false, type: "", maxLength: 20 },
      {
        key: "余额",
        value: ticketAmount,
        notNull: true,
        type: "number",
        maxLength: 10,
      },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    console.log(`----- doUpdateLine 2`);

    const rst = await updateTicket({
      subarea,
      ID,
      ticketNo,
      ticketAmount,
      ticketHolder,
      mobileNumber,
      idCard,
      buyer,
      mobileNumber2,
      idCard2,
      relationship,
      startDate,
      endDate,
      remarks,
    });
    console.log(`----- doUpdateLine 3`);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "更新房票失败");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "更新房票成功");
      store.search();
      this.closeUpdateTicketDialog();
      return true;
    }
  }

  closeUpdateTicketDialog() {
    this.setState({
      updateTicketDialogOpen: false,
      updateTicketParams: {
        subarea: '',
        ID: "",
        ticketNo: "",
        ticketHolder: "",
        mobileNumber: "",
        idCard: "",
        buyer: "",
        mobileNumber2: "",
        idCard2: "",
        relationship: "",
        validPeriod: "",
        remarks: "",
        ticketAmount: "",
      },
    });
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      {
        id: "subarea",
        align: "right",
        disablePadding: true,
        label: "区域",
        sortable: true,
      },
      {
        id: "ticketNo",
        align: "right",
        disablePadding: true,
        label: "票号",
        sortable: true,
      },
      {
        id: "ticketHolder",
        align: "right",
        disablePadding: false,
        label: "名称",
        sortable: true,
      },
      {
        id: "mobileNumber",
        align: "right",
        disablePadding: false,
        label: "手机号",
        sortable: true,
      },
      {
        id: "idCard2",
        align: "right",
        disablePadding: true,
        label: "身份证号码",
        sortable: true,
      },
      {
        id: "relationship",
        align: "right",
        disablePadding: true,
        label: "关系",
        sortable: true,
      },
      {
        id: "ticketAmount",
        align: "right",
        disablePadding: true,
        label: "余额",
        sortable: false,
      },
      {
        id: "ticketOrgAmount",
        align: "right",
        disablePadding: true,
        label: "初始金额",
        sortable: false,
      },
      { id: "state", align: "right", disablePadding: true, label: "状态", sortable: true, },
      {
        id: "purchaseStatus",
        align: "right",
        disablePadding: true,
        label: "购房状态",
        sortable: true,
      },
      {
        id: "validPeriod",
        align: "right",
        disablePadding: true,
        label: "房票有效期",
        sortable: true,
      },
      {
        id: "remarks",
        align: "center",
        disablePadding: true,
        label: "备注",
        sortable: true,
      },
      {
        id: "actions",
        align: "center",
        disablePadding: true,
        label: "操作",
        sortable: false,
      },
    ];

    const emptyRows = Math.max(10 - store.table.length, 0);

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer style={{ maxHeight: this.state.tableContainerHeight }}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding="none"
                      sortDirection={
                        store.tableConfig.orderBy === headCell.id
                          ? store.tableConfig.order
                          : false
                      }
                      id="TableOfTicket"
                    >
                      {headCell.sortable && (
                        <TableSortLabel
                          active={store.tableConfig.orderBy === headCell.id}
                          direction={
                            store.tableConfig.orderBy === headCell.id
                              ? store.tableConfig.order
                              : "asc"
                          }
                          onClick={(event) =>
                            this.sortHandler(event, headCell)
                          }
                        >
                          {headCell.label}
                          {store.tableConfig.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {store.tableConfig.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}

                      {!headCell.sortable && (
                        <TableSortLabel hideSortIcon>
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.table,
                  this.getComparator(
                    store.tableConfig.order,
                    store.tableConfig.orderBy
                  )
                ).map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  if (!row.ticketNo) return null;
                  return (
                    <TableRow hover tabIndex={-1} key={row.ID}>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.subarea}
                      </TableCell>
                      <TableCell
                        component="th"
                        align="right"
                        id={labelId}
                        scope="row"
                        padding="none"
                        className={classes.TableCell}
                      >
                        {row.ticketNo}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        <div>被搬迁户：{row.ticketHolder}</div>
                        <div>房票使用人：{row.buyer}</div>
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        <div>被搬迁户：{row.mobileNumber}</div>
                        <div>房票使用人：{row.mobileNumber2}</div>
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        <div>被搬迁户：{row.idCard}</div>
                        <div>房票使用人：{row.idCard2}</div>
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.relationship}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.ticketAmount}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.ticketOrgAmount}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.state === "2" ? "已生效" : "未生效"}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        {row.purchaseStatus === "2" ? "已购房" : "未购房"}
                      </TableCell>
                      <TableCell align="right" padding="none" className={classes.TableCell}>
                        <div>{row.validPeriod.split(" ")[0]}</div>
                        <div>{row.validPeriod.split(" ")[1]}</div>
                      </TableCell>
                      <TableCell align="left" padding="normal"
                        style={{ maxWidth: '200px' }}
                        className={classes.TableCell}
                      >
                        {row.remarks}
                      </TableCell>
                      <TableCell
                        align="center"
                        padding="none"
                        style={{ width: "100px" }}
                        className={classes.TableCell}
                      >
                        <ButtonGroup
                          variant="contained"
                          aria-label="contained primary button group"
                        >
                          {
                            getIfFuncAuthorized("房票管理-房票信息管理-修改")
                            && (
                              <Button
                                color="primary"
                                onClick={(e) => this.updateLine(e, row)}
                                disabled={row.state !== "1"}
                              >
                                修改
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-房票信息管理-审核")
                            && (
                              <Button
                                color="primary"
                                disabled={row.state !== "1"}
                                onClick={(e) =>
                                  this.verifyTicket(e, row, index)
                                }
                              >
                                审核
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-房票信息管理-反审")
                            && (
                              <Button
                                color="primary"
                                disabled={
                                  !(
                                    row.state === "2" &&
                                    row.purchaseStatus !== "2"
                                  )
                                }
                                onClick={(e) =>
                                  this.unverifyTicket(e, row, index)
                                }
                              >
                                反审
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-房票信息管理-司法上传")
                            && (
                              <Button
                                color="primary"
                                disabled={!(row.state === "1")}
                                onClick={(e) =>
                                  this.openUploadImagesDialog(e, row.ID)
                                }
                              >
                                司法上传
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-房票信息管理-查看附件") && (
                            <Button
                              color="primary"
                              onClick={(e) => this.showAttachment(e, row)}
                            >
                              查看附件
                            </Button>
                          )}
                          {getIfFuncAuthorized("房票管理-房票信息管理-删除")
                            && (
                              <Button
                                color="secondary"
                                disabled={!(row.state === "1")}
                                onClick={(e) => this.openDeleteLineDialog(e, row.ID)}
                              >
                                删除
                              </Button>
                            )}
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 110 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.tableCount}
            rowsPerPage={store.tableConfig.rowsPerPage}
            page={store.tableConfig.currentPage}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>

        {/* 司法上传 */}
        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.uploadImagesDialogOpen}
          onClose={this.closeUploadImagesDialog}
        >
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            司法上传
          </DialogTitle>
          <DialogContent>
            <input
              accept="image/*"
              onChange={(e) => this.uploadProfilePic(e)}
              style={{ display: "none" }}
              id="contained-button-file"
              multiple
              type="file"
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                className={classes.button}
              >
                上传图片
              </Button>
            </label>
            <ImageList className={classes.imageList}>
              {this.state.imgInfoList.map((item, index) => {
                if (!item.display) return null;
                return (
                  <ImageListItem
                    key={index}
                    onClick={(e) => this.openBigImageDialog(item.url)}
                  >
                    <img src={item.url} alt={"" && "item.title"} />
                    <ImageListItemBar
                      title={"" && "item.title"}
                      subtitle={"" && <span>by: {"item.author"}</span>}
                      onClick={(e) => this.deleteImage(e, item, index)}
                      actionIcon={
                        <IconButton
                          aria-label={"" && `info about ${"item.title"}`}
                          className={classes.icon}
                        >
                          删除
                        </IconButton>
                      }
                    />
                  </ImageListItem>
                );
              })}
            </ImageList>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.uploadImages}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认上传
            </Button>
            <Button
              onClick={this.closeUploadImagesDialog}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

        {/* 查看附件 */}
        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.attachmentDialogOpen}
          onClose={this.closeAttachmentDialog}
        >
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            查看附件
          </DialogTitle>
          <DialogContent>
            <ImageList className={classes.imageList}>
              {this.state.imgInfoList.map((item, index) => {
                if (!item.display) return null;
                return (
                  <ImageListItem
                    key={index}
                    onClick={(e) => this.openBigImageDialog(item.url)}
                  >
                    <img src={item.url} alt={"" && "item.title"} />
                  </ImageListItem>
                );
              })}
            </ImageList>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeAttachmentDialog}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              关闭
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.updateTicketDialogOpen}
          onClose={(e) => this.closeUpdateTicketDialog(e)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">修改房票</DialogTitle>
          <DialogContent>
            <ITextField
              margin="dense"
              id="subarea"
              label="区域（非必输）"
              fullWidth
              ivalue={this.state.updateTicketParams.subarea}
              onChange={(e) => this.onTicketDialogChange(e, "subarea")}
              type=""
              maxLength="20"
            />
            <ITextField
              autoFocus
              margin="dense"
              id="ticketNo"
              label="*票号"
              fullWidth
              ivalue={this.state.updateTicketParams.ticketNo}
              onChange={(e) => this.onTicketDialogChange(e, "ticketNo")}
              type="int"
              maxLength="20"
              notNull
            />
            <ITextField
              margin="dense"
              id="ticketHolder"
              label="*被搬迁户"
              fullWidth
              ivalue={this.state.updateTicketParams.ticketHolder}
              onChange={(e) => this.onTicketDialogChange(e, "ticketHolder")}
              type=""
              maxLength="20"
              notNull
            />
            <ITextField
              margin="dense"
              id="mobileNumber"
              label="*被搬迁户手机号"
              fullWidth
              ivalue={this.state.updateTicketParams.mobileNumber}
              onChange={(e) => this.onTicketDialogChange(e, "mobileNumber")}
              type="phone"
              maxLength="11"
              notNull
            />
            <ITextField
              margin="dense"
              id="idCard"
              label="*被搬迁户身份证号码"
              fullWidth
              ivalue={this.state.updateTicketParams.idCard}
              onChange={(e) => this.onTicketDialogChange(e, "idCard")}
              type="idnum"
              maxLength="18"
              notNull
            />
            <ITextField
              margin="dense"
              id="buyer"
              label="*房票使用人"
              fullWidth
              ivalue={this.state.updateTicketParams.buyer}
              onChange={(e) => this.onTicketDialogChange(e, "buyer")}
              type=""
              maxLength="20"
              notNull
            />
            <ITextField
              margin="dense"
              id="mobileNumber2"
              label="*房票使用人手机号"
              fullWidth
              ivalue={this.state.updateTicketParams.mobileNumber2}
              onChange={(e) => this.onTicketDialogChange(e, "mobileNumber2")}
              type="phone"
              maxLength="11"
              notNull
            />
            <ITextField
              margin="dense"
              id="idCard2"
              label="*房票使用人身份证号码"
              fullWidth
              ivalue={this.state.updateTicketParams.idCard2}
              onChange={(e) => this.onTicketDialogChange(e, "idCard2")}
              type="idnum"
              maxLength="18"
              notNull
            />
            <ITextField
              margin="dense"
              id="relationship"
              label="*被搬迁户与房票使用人关系"
              fullWidth
              ivalue={this.state.updateTicketParams.relationship}
              onChange={(e) => this.onTicketDialogChange(e, "relationship")}
              type=""
              maxLength="20"
              notNull
            />
            <ITextField
              margin="dense"
              id="ticketAmount"
              label="*余额"
              fullWidth
              ivalue={this.state.updateTicketParams.ticketAmount}
              onChange={(e) => this.onTicketDialogChange(e, "ticketAmount")}
              type="number"
              maxLength="10"
              notNull
            />
            <ITextField
              margin="dense"
              id="startDate"
              label="*房票有效期-开始日期"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dateField}
              ivalue={this.state.updateTicketParams.startDate}
              onChange={(e) => this.onTicketDialogChange(e, "startDate")}
              type="date"
              maxLength="10"
              notNull
            />
            <ITextField
              margin="dense"
              id="endDate"
              label="*房票有效期-结束日期"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dateField}
              ivalue={this.state.updateTicketParams.endDate}
              onChange={(e) => this.onTicketDialogChange(e, "endDate")}
              type="date"
              maxLength="10"
              notNull
            />
            <ITextField
              margin="dense"
              id="remarks"
              label="*备注"
              fullWidth
              ivalue={this.state.updateTicketParams.remarks}
              onChange={(e) => this.onTicketDialogChange(e, "remarks")}
              type=""
              maxLength="20"
              notNull={false}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => this.doUpdateLine(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认修改
            </Button>
            <Button
              onClick={(e) => this.closeUpdateTicketDialog(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

        {/* 大图显示 */}
        <Dialog
          fullScreen
          open={this.state.bigImageDialogOpen}
          onClose={(e) => this.closeBigImageDialog()}
          color="inherit"
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={(e) => this.closeBigImageDialog()}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Button
                autoFocus
                color="inherit"
                onClick={(e) => this.closeBigImageDialog()}
              >
                <Typography variant="h6">关闭</Typography>
              </Button>
            </Toolbar>
          </AppBar>
          <img src={this.state.bigImageUrl} alt={"" && "item.title"} />
        </Dialog>

        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfRoomTicketInfoManagement = observer(
  TableOfRoomTicketInfoManagementInner
);

TableOfRoomTicketInfoManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfRoomTicketInfoManagement);
